import { SMSCourseConstants } from '../_constants';

export function smsCourse(state = {}, action) {
  switch (action.type) {
    case SMSCourseConstants.GETALL_REQUEST:
      return {
        loading: true
      };
    case SMSCourseConstants.GETALL_SUCCESS:
      return {
        courses: action.courses
      };
    case SMSCourseConstants.GETALL_FAILURE:
      return { 
        error: action.error
      };

    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/_reducers/sms-course.reducer.js